module.exports = __webpack_public_path__ + "img/landliebe-6368.67893f45.jpeg";